import React, { Fragment } from "react";
import { Route, Switch } from "react-router-dom";
import Login from "../auth/Login";
import SetPassword from "../auth/SetPassword";
import Dashboard from "../dashboard/Dashboard";
import DailyIncome from "../dashboard/DailyIncome";
import TenantDashboard from "../tenant/TenantDashboard";
import PrivateRoute from "../routing/PrivateRoute";
import Printer from "../printer/Printer";
import Ebarimt from "../ebarimt/Ebarimt";
import Settings from "../settings/Settings";
import Log from "../log/Log";
import Satisfaction from "../satisfaction/Satisfaction";
import PrintErrors from "../printError/PrintErrors";
import Templates from "../template/Templates";
import TemplateEdit from "../template/TemplateEdit";
import TemplateThemes from "../template/TemplateThemes";
import Users from "../users/Users";
import Tenants from "../tenant/Tenants";
import Plan from "../plan/Plan";
import Campaigns from "../ads/Campaigns";
import AdReport from "../ads/AdReport";
import Bundles from "../bundle/Bundles";
import Service from "../service/Service";

const Routes = () => {
  return (
    <Fragment>
      <Switch>
        <Route exact path="/" component={Login} />
        <Route exact path="/set-password" component={SetPassword} />
        <PrivateRoute exact path="/dashboard" section="dashboard" component={Dashboard} />
        <PrivateRoute exact path="/income" section="dashboard" component={DailyIncome} />
        <PrivateRoute exact path="/tenant" section="tenantDashboard" component={TenantDashboard} />
        <PrivateRoute exact path="/printer" section="printer" component={Printer} />
        <PrivateRoute exact path="/service" section="service" component={Service} />
        <PrivateRoute exact path="/settings" section="settings" component={Settings} />
        <PrivateRoute exact path="/ebarimt" section="ebarimt" component={Ebarimt} />
        <PrivateRoute exact path="/log" section="log" component={Log} />
        <PrivateRoute exact path="/plan" section="plan" component={Plan} />
        <PrivateRoute exact path="/bundles" section="bundles" component={Bundles} />
        <PrivateRoute exact path="/satisfaction" section="satisfaction" component={Satisfaction} />
        <PrivateRoute exact path="/print-errors" section="printErrors" component={PrintErrors} />
        <PrivateRoute exact path="/templates" section="templates" component={Templates} />
        <PrivateRoute exact path="/template-edit" section="templates" component={TemplateEdit} />
        <PrivateRoute exact path="/template-themes" section="templates" component={TemplateThemes} />
        <PrivateRoute exact path="/ads" section="ads" component={Campaigns} />
        <PrivateRoute exact path="/ad-report" section="ads" component={AdReport} />
        <PrivateRoute exact path="/users" section="admins" component={Users} />
        <PrivateRoute exact path="/tenants" section="tenants" component={Tenants} />
      </Switch>
    </Fragment>
  );
};

export default Routes;
